<div class="choose-language" *ngIf="isMobileApp">
  <div class="cl-status-spacer"></div>

  <button type="button" class="cl-back-btn" (click)="goBack()" aria-label="Back">
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M15 6L9 12L15 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  </button>

  <h1>{{ 'CHOOSE_LANGUAGE.TITLE' | translate }}</h1>
  <p class="cl-subtitle">{{ 'CHOOSE_LANGUAGE.SUBTITLE' | translate }}</p>

  <div class="cl-card">
    <ul class="cl-lang-list">
      <li
        class="cl-lang-row"
        *ngFor="let lang of languages"
        (click)="selectLang(lang.code)"
        [class.cl-lang-selected]="selectedLang === lang.code"
      >
        <span [ngClass]="['fi', lang.flagClass]"></span>
        <span class="cl-lang-name">{{ lang.labelKey | translate }}</span>
        <span class="cl-check" *ngIf="selectedLang === lang.code">✓</span>
      </li>
    </ul>
  </div>

  <button type="button" class="cl-continue-btn" (click)="onContinue()">
    {{ 'CHOOSE_LANGUAGE.CONTINUE_BTN' | translate }}
  </button>

  <div class="cl-home-indicator"></div>
</div>
